import clsx from 'clsx';
import { formatCurrency } from 'shared/util/formatCurrency';
import { ProductType } from 'screens/SelectServices/schemas';

interface StarlinkServiceSummaryProps {
  data: ProductType | undefined;
  isPinnedSummary?: boolean;
  isDisabled?: boolean;
  graniteInstall?: boolean;
}

export const StarlinkServiceSummary = ({
  data,
  isPinnedSummary = false,
  isDisabled = false,
  graniteInstall,
}: StarlinkServiceSummaryProps) => {
  const pricing = data?.formal_starlink_pricing;

  const totalMRC = pricing?.total_mrc ?? 0;

  return (
    <div className="max-w-fit font-bold md:max-w-full">
      <div className="mb-1 mt-6 text-xs text-content-base-default">
        Non-recurring charges
      </div>
      <div className="mb-1 flex w-full justify-between gap-4">
        <div>Equipment bundle</div>
        <div className={clsx('text-content-base-default')}>
          {formatCurrency(pricing?.enterprise_bundle)}
        </div>
      </div>
      <div className="mb-1 flex w-full justify-between gap-4">
        <div>Service activation fee</div>
        <div className={clsx('text-content-base-default')}>
          {formatCurrency(pricing?.activation)}
        </div>
      </div>

      <div
        className={clsx(
          'mb-4 flex w-full justify-between gap-4',
          !graniteInstall && 'invisible',
        )}
      >
        <div>Install add-on</div>
        <div className={clsx('text-content-base-default')}>
          {formatCurrency(pricing?.installation)}*
        </div>
      </div>

      <div className="mb-1 text-xs text-content-base-default">
        Monthly recurring charges
      </div>

      <div className="mb-1 flex w-full justify-between gap-4">
        <div>Main service plan</div>
        <div className={clsx('text-content-base-default')}>
          {formatCurrency(totalMRC)}
        </div>
      </div>
      <div className="flex justify-between gap-4">
        <div className="">Monthly price</div>
        <div
          className={clsx(
            'text-xl transition-colors duration-500',
            'text-content-base-subdued',
            isPinnedSummary && 'text-purple-300',
            isDisabled && '!text-content-base-default',
          )}
        >
          {formatCurrency(totalMRC)}
        </div>
      </div>
    </div>
  );
};
